<template>
  <v-autocomplete
      :items="allCountries"
      ref="textField"
      :label="label"
      v-model="internalValue"
      :clearable="!nullableMode"
      :messages="messages"
      :success-messages="successMessages"
      :error-count="errormessages[itemId] ? (errormessages[itemId].length || 1) : 1"
      :error-messages="errormessages[itemId] ? errormessages[itemId] : []"
      @input="clearErrors"
      :rules="rules ? rules : []"
  >
    <template v-slot:append v-if="nullableMode && (value !== null)">
      <v-btn icon small @click="internalValue = null" >
        <v-icon dense>mdi-close</v-icon>
      </v-btn>
    </template>
  </v-autocomplete>
</template>

<script>
import {mapGetters} from 'vuex'
import countries from 'i18n-iso-countries'

export default {
  name: "NullableAutocompete",
  props: ['value', 'nullableMode', 'label', 'errors', 'itemId', 'rules'],
  data() {
    return {
      // eslint-disable-next-line vue/no-reserved-keys
      internalValue: '',
      internalErrormessages: []
    }
  },

  watch: {
    itemId: {
      // eslint-disable-next-line object-shorthand
      handler: function(v) {
        if (typeof this.internalErrormessages[v] === 'undefined') {
          this.internalErrormessages[v] = (this.errors && this.errors.length) ? this.errors.map(e => e.errormsg[this.locale]) : []
        }
      },
      immediate: true
    },
    value(v) {
      this.internalValue = v;
    },
    internalValue(v) {
      this.$emit('input', v);
    }
  },

  methods: {
    clearErrors() {
      if (!this.nullableMode) {
        this.internalErrormessages[this.itemId] = []
      }
    }
  },

  computed: {
    ...mapGetters('app', ['locale']),

    messages() {
      return this.nullableMode ? this.value === null ? [this.$t('rights.editForm.noChanges')] : [] : [];
    },

    successMessages() {
      return this.nullableMode ? this.value === null ? [] : [this.$t('rights.editForm.willEdit')] : [];
    },

    errormessages() {
      return this.nullableMode ? [] : this.internalErrormessages
    },

    allCountries() {
      countries.registerLocale(require(`i18n-iso-countries/langs/${this.locale}.json`))
      const allC = Object.entries(countries.getNames(this.locale)).map(([k,v]) => {
        return {value: k, text: `${k} - ${v}`}
      })
      if (this.nullableMode) {
        allC.unshift({value: '**', text: `** - ${this.$t('rights.editForm.clearValue')}`})
      }
      return allC
    },

  },
  mounted() {
    this.internalValue = this.value;
  }
}
</script>